import { useState, useRef } from 'react';
import { getTodayKey } from './complianceUtils';
import './ComplianceNotes.css';

function formatNoteDate(dateStr, editable = false) {
    const d = new Date(dateStr + 'T00:00:00');
    const label = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    return editable && dateStr === getTodayKey() ? `${label} (click to edit)` : label;
}

function ComplianceNotes({ selectedDate, selectedNote, onNoteChange, allNotes, readOnly }) {
    const [editing, setEditing] = useState(false);
    const textareaRef = useRef(null);
    const otherNotes = allNotes.filter(n => n.date !== selectedDate);
    const hasAnyContent = selectedNote || otherNotes.length > 0;

    if (readOnly && !hasAnyContent) return null;

    const handleFocus = () => {
        setEditing(true);
    };

    const handleBlur = () => {
        setEditing(false);
    };

    const handleDisplayClick = () => {
        setEditing(true);
        setTimeout(() => textareaRef.current?.focus(), 0);
    };

    return (
        <div className="cn-root">
            {!readOnly && (
                <div className="cn-current">
                    {editing ? (
                        <textarea
                            ref={textareaRef}
                            className="cn-textarea"
                            placeholder="Add a note..."
                            value={selectedNote}
                            onChange={(e) => onNoteChange(e.target.value)}
                            onBlur={handleBlur}
                            rows={2}
                            autoFocus
                        />
                    ) : selectedNote ? (
                        <div className="cn-history-item cn-history-item--current" onClick={handleDisplayClick}>
                            <span className="cn-history-date">{formatNoteDate(selectedDate, true)}</span>
                            <p className="cn-history-text">{selectedNote}</p>
                        </div>
                    ) : (
                        <textarea
                            className="cn-textarea"
                            placeholder="Add a note..."
                            value=""
                            onChange={(e) => onNoteChange(e.target.value)}
                            onFocus={handleFocus}
                            rows={2}
                        />
                    )}
                </div>
            )}

            {readOnly && selectedNote && (
                <div className="cn-current">
                    <div className="cn-history-item">
                        <span className="cn-history-date">{formatNoteDate(selectedDate)}</span>
                        <p className="cn-history-text">{selectedNote}</p>
                    </div>
                </div>
            )}

            {otherNotes.length > 0 && (
                <div className="cn-history">
                    {otherNotes.map(n => (
                        <div key={n.date} className="cn-history-item">
                            <span className="cn-history-date">{formatNoteDate(n.date)}</span>
                            <p className="cn-history-text">{n.note}</p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default ComplianceNotes;
